module.exports = __webpack_public_path__ + "img/home.fe4be81c.png";